import { jsxs as E, jsx as a } from "react/jsx-runtime";
import { clsx as p } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useBreakpointMatch as k } from "../../../utils/use-breakpoint-match.js";
import { RocheUIPharmaCardVariant as N } from "../pharma-card/roche-pharma-card.types.js";
import { RocheUIPipelineLaneRow as f } from "../pipeline-lane-row/roche-pipeline-lane-row.js";
import { PIPELINE_MOBILE_BREAKPOINT as U } from "../pipeline-lanes.js";
import { getPipelineChangesLaneStates as S } from "./roche-pipeline-changes-track.helpers.js";
import i from "./roche-pipeline-changes-track.module.scss.js";
import { RocheUIPipelineChangesLaneState as n } from "./roche-pipeline-changes-track.types.js";
const j = ({
  lanes: s,
  activeLaneId: _,
  previousLaneId: P,
  variant: R = N.OTHER,
  renderItem: h,
  mobileItem: I
}) => {
  const v = k(U), o = S(s, _, P), d = p(i["pipeline-changes-track"], i[`pipeline-changes-track--${R}`]), l = o.indexOf(n.PREVIOUS), m = o.indexOf(n.CURRENT), e = l === -1 ? void 0 : { start: Math.min(l, m + 1), end: Math.max(l, m - 1) }, u = (t) => !!(e && t > e.start && t <= e.end), g = e ? { gridColumn: `span ${e.end - e.start + 1}` } : void 0;
  return v ? /* @__PURE__ */ E("div", { className: d, children: [
    /* @__PURE__ */ a(f, { laneCount: s.length, hasTightGap: !0, children: s.map((t, r) => {
      if (u(r))
        return null;
      const c = r === (e == null ? void 0 : e.start), C = c ? n.PREVIOUS : o[r];
      return /* @__PURE__ */ a(
        "div",
        {
          className: p(
            i["pipeline-changes-track__lane"],
            i[`pipeline-changes-track__lane--${C}`]
          ),
          style: c ? g : void 0,
          "aria-hidden": "true"
        },
        t.id
      );
    }) }),
    I
  ] }) : /* @__PURE__ */ a("div", { className: d, children: /* @__PURE__ */ a(f, { laneCount: s.length, hasTightGap: !0, children: s.map((t, r) => {
    const c = o[r];
    return u(r) ? null : r === (e == null ? void 0 : e.start) ? /* @__PURE__ */ a(
      "div",
      {
        className: i["pipeline-changes-track__cell"],
        style: g,
        "aria-hidden": "true",
        children: h(n.PREVIOUS)
      },
      t.id
    ) : c === n.CURRENT ? /* @__PURE__ */ a("div", { className: i["pipeline-changes-track__cell"], children: h(n.CURRENT) }, t.id) : /* @__PURE__ */ a(
      "div",
      {
        className: p(i["pipeline-changes-track__cell"], i[`pipeline-changes-track__cell--${c}`]),
        "aria-hidden": "true"
      },
      t.id
    );
  }) }) });
};
export {
  j as RocheUIPipelineChangesTrack
};
